<template>
    <div class="home-exam">
        <div class="home-exam-box">
            <div class="home-exam-box-head">
                <h3>公共考試</h3>
                <exam-search @search="searchChange"></exam-search>
            </div>
            <div class="home-exam-box-con">
                <butt-tab :tabList="tabList" @tabChange="tabChange" :tabIndex="tabIndex"></butt-tab>
                <el-row :gutter="68" v-loading="loading">
                    <el-col :span="6" v-for="(item,index) in list.data" :key="index">
                        <div @click="$router.push({path:'/exam/list',query:{type:tabList[tabIndex].type,id:item.id,index:tabIndex,title:item.name}})">
                            <lesson-exam-card
                            :imgSrc="require('@p/assets/images/exam.png')"
                            :title="item.name"
                            :describe="`收录考卷：${item.exam_count}张`"
                            :state="tabList[tabIndex].label"
                            :icon="tabList[tabIndex].icon"
                            :styles="{color:'#4D8EF6'}"
                            class="p-pointer"
                            />
                        </div>
                    </el-col>
                </el-row>
                <div v-if="list.data && list.data.length == 0" style="padding-top:100px">
                    <empty title="暫無考試" ></empty>
                </div>
            </div>
        </div>
        <div class="pagination flex-center">
            <el-pagination background @current-change="currentChange" :current-page="list.current_page" layout="prev, pager, next" :total="list.total" :page-size="12">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import examSearch from '@p/components/exam/search'
import buttTab from '@p/components/varietyTab/buttTab'
import lessonExamCard from '@p/components/lessonExamCard';
import empty from '@p/components/contentEmpty';

export default {
    data(){
        return {
            lesson:100,
            currentPage: 1,
            loading:false,
            tabIndex:0,
            tabList: [
                {label: '已結束',type:'completed',icon:'el-icon-success'},
                {label: '考試中',type:'progress',icon:'el-icon-edit'},
                {label: '未開始',type:'not_start',icon:'el-icon-time'},
            ],    
            list:{},
            search:'',
        }
    },
    created(){
        if(this.$route.query.index){
            this.tabIndex=this.$route.query.index;
        }
        this.initData();
    },
    watch:{
        '$route.query':function(v){
            this.tabIndex=v.index;
            this.initData()
        },
    },
    methods:{
        async initData(status=this.tabList[this.tabIndex].type,search=this.search,page_size=12,page=1){
            this.loading=true;
            await this.$http.examination.lists({status,search,page_size,page}).then(v=>{
                if(v.status === 200 && v.data.status_code === 200){
                    this.list=v.data.data;
                }
                this.loading=false;
            }).catch(er=>{this.loading=false;})
        },
        searchChange(v){
            this.search=v;
            
            this.initData(undefined,v)
        },
        //分页
        currentChange(page) {
            this.initData(undefined,undefined,undefined,page)
        },
        //tab
        tabChange(v){
            this.tabIndex=v;
            // this.initData()
            this.$router.replace({path:'/home/exam',query:{index:this.tabIndex,title:'考試'}})
        },
    },
    components:{
        examSearch,buttTab,lessonExamCard,empty
    }
}
</script>
<style lang="less" scoped>
.home-exam{
    margin-top: 36px;
    &-box{
        min-height: 757px;
        border:1px solid rgba(228,231,237,1);
        box-shadow:0px 3px 6px rgba(51,51,51,0.1);
        &-head{
            height:64px;
            background:rgba(244,244,249,1);
            border-bottom:1px solid rgba(228,231,237,1);
            display: flex;
            align-items: center;
            h3{
                margin-left: 31px;
                margin-right: 22px;
                color: #333333;
                font-size:16px;
            }
        }
        &-con{
            padding: 21px 31px 29px;
            .el-col{
                margin-top: 21px;
            }
        }
    }
    .pagination{
        margin: 32px 0;
    }
}
</style>